import React, { Component } from 'react';
import { NavMenu } from './NavMenu';
import { SessionGuard } from './SessionGuard';
import OfflineBanner from './OfflineBanner';
import SyncStatusBadge from './SyncStatusBadge';
import { PageMetaProvider } from '../hooks/usePageMeta';
import { DocumentTitle } from './DocumentTitle';
import { Topbar, TopbarActions } from './ui';
import { GlobalSearch } from './search/GlobalSearch';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <PageMetaProvider>
        <div>
          <DocumentTitle />
          <SessionGuard />
          <OfflineBanner />
          <NavMenu />
          <main className="app-content">
            <Topbar
              searchSlot={<GlobalSearch />}
              actions={<TopbarActions />}
            />
            <div className="app-content-body">
              {this.props.children}
            </div>
          </main>
          <SyncStatusBadge />
        </div>
      </PageMetaProvider>
    );
  }
}
